import React, { FC } from 'react';
import { Button, Form, Typography, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { SendMoneyState } from '~/types';

interface InputAccountNumberProps {
  mainState: SendMoneyState;
  setMainState: React.Dispatch<React.SetStateAction<SendMoneyState>>;
  onNext: (recipientAccountNumber: string) => void;
  isLoading?: boolean;
}

const InputAccountNumber: FC<InputAccountNumberProps> = ({
  mainState,
  setMainState,
  onNext,
  isLoading,
}) => {
  const { t } = useTranslation('sendMoney');
  const [form] = Form.useForm();

  const handleFinish = ({ recipientAccountNumber }: { recipientAccountNumber: string }) => {
    onNext(recipientAccountNumber);
  };

  return (
    <div>
      <Typography.Title level={4} style={{ fontWeight: 500 }}>
        {t('recipientAccountNumber')}
      </Typography.Title>
      <Form
        layout="vertical"
        form={form}
        name="inputAccountForm"
        onFinish={handleFinish}
        onValuesChange={(_, values) => setMainState((prev) => ({ ...prev, ...values }))}
        initialValues={{ recipientAccountNumber: mainState?.recipientAccountNumber }}
      >
        <Form.Item
          name="recipientAccountNumber"
          rules={[{ required: true, message: t('inputAccountNumber') }]}
        >
          <Input />
        </Form.Item>
        <Button
          type="primary"
          block
          htmlType="submit"
          style={{ marginTop: 16 }}
          loading={isLoading}
          disabled={!mainState.recipientAccountNumber}
        >
          {!mainState.recipientAccountNumber ? t('inputAccountNumber') : t('continue')}
        </Button>
      </Form>
    </div>
  );
};

export default InputAccountNumber;
